import React from 'react';
import './DismissModal.css';
import { X, CheckCircle, AlertTriangle } from 'lucide-react';

interface DismissModalProps {
  itemId: number;
  itemTitle: string;
  itemType: 'alert' | 'insight';
  onClose: () => void;
  onDismiss: (reason: 'finished' | 'irrelevant') => void;
}

const DismissModal: React.FC<DismissModalProps> = ({ 
  itemId, 
  itemTitle, 
  itemType,
  onClose, 
  onDismiss 
}) => {
  const handleDismiss = (reason: 'finished' | 'irrelevant') => {
    onDismiss(reason);
    onClose();
  };

  const itemTypeText = itemType === 'alert' ? 'alert' : 'insight';

  return (
    <div className="dismiss-modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <div className="dismiss-modal-container">
        <div className="dismiss-modal-header">
          <h3>Why are you dismissing this {itemTypeText}?</h3>
          <button 
            type="button"
            className="dismiss-modal-close-btn" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
          >
            <X size={20} />
          </button>
        </div>
        
            <div className="dismiss-modal-content">
              <p className="dismiss-modal-explanation">
                Your feedback helps us improve {itemTypeText} accuracy and train our system to better understand what's relevant to your properties.
              </p>
              
              <div className="dismiss-options">
            <button 
              type="button"
              className="dismiss-option finished"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleDismiss('finished');
              }}
            >
              <CheckCircle size={24} />
              <div className="dismiss-option-content">
                <h4>I'm finished with this {itemTypeText}</h4>
                <p>I've reviewed it and don't need to see it anymore</p>
              </div>
            </button>
            
            <button 
              type="button"
              className="dismiss-option irrelevant"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleDismiss('irrelevant');
              }}
            >
              <AlertTriangle size={24} />
              <div className="dismiss-option-content">
                <h4>This {itemTypeText} is not relevant to me</h4>
                <p>This {itemTypeText} doesn't relate to my property or interests</p>
              </div>
            </button>
          </div>
          
          <div className="dismiss-modal-footer">
            <button 
              type="button"
              className="btn btn-secondary" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DismissModal;
